exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#videoInspectionCardModal .v--modal-box.v--modal{min-height:500px!important;min-width:680px!important}#videoInspectionCardModal #attr__wrapper .layout:not(#geometry-panel){margin-top:20px}#videoInspectionCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#videoInspectionCardModal .v-tabs__div:not(:last-child){padding-right:5px}#videoInspectionCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#videoInspectionCardModal .v-select__selection,#videoInspectionCardModal .v-select__slot input{font-size:12px!important}.btnDisabled{pointer-events:none!important;color:#888!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae5a220e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/video/modals/VideoInspectionCard.vue
// module id = 2014
// module chunks = 0